<section class="cmt-assign" [class.close]="shouldClose" *ngIf="oid">

  <div class="cmt-assign-container">

    <div class="closeButton" (click)="closeClicked()"></div>

    <div style="display:flex">
      <kendo-grid [kendoGridBinding]="gridView"
                  kendoGridSelectBy="id"
                  [selectable]="selectableSettings"
                  (selectionChange)="onSelect($event)"
                  [(selectedKeys)]="selectedIds"
                  [pageable]="true"
                  [pageSize]="10"
                  [height]="500"
                  [sortable]="true"
                  [filterable]="'menu'"
                  style="width:100%">
        <kendo-grid-column field="id" title="ID" [width]="220">
        </kendo-grid-column>
        <kendo-grid-column field="name" title="{{'calculationModel.name' |  translate | uppercase}}" [width]="220">
        </kendo-grid-column>
        <kendo-grid-column field="country" [title]="'calculationModel.country' | translate | uppercase" [width]="220">
        </kendo-grid-column>
        <kendo-grid-column field="sector" [title]="'calculationModel.sector' | translate | uppercase" [width]="220">
        </kendo-grid-column>
        <kendo-grid-column field="valuationMethod" [title]="'calculationModel.valuationMethod' | translate | uppercase" [width]="220">
        </kendo-grid-column>
      </kendo-grid>
    </div>

    <div class="buttons-container">
      <button kendoButton class="next" *ngIf="selectedIds.length > 0" (click)="applyToProperties()">{{'calculationModel.applyToProperties' | translate}}</button>
      <button kendoButton class="next" *ngIf="propertyIds.length > 0" (click)="removeFromProperties()">{{'calculationModel.removeFromProperties' | translate}}</button>
    </div>

  </div>

</section>
